import { ItemList } from '../../orm'

class UserList extends ItemList {
    getEntityKey() {
        return "admin/user"
    }
}

export const adminUserList = new UserList("admin_user__default")
